import { render, staticRenderFns } from "./PortalAlertTable.vue?vue&type=template&id=31294577&scoped=true&"
import script from "./PortalAlertTable.vue?vue&type=script&lang=js&"
export * from "./PortalAlertTable.vue?vue&type=script&lang=js&"
import style0 from "./PortalAlertTable.vue?vue&type=style&index=0&id=31294577&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31294577",
  null
  
)

export default component.exports